import { AlphabetCollectionsDraftApi, useAPIAction } from "melco-shared-logic";

export const useDuplicateFontCollection = (fontCollectionId: string) => {
  return useAPIAction(
    AlphabetCollectionsDraftApi,
    async (api) => {
      const data = await api.userAlphabetCollectionsDuplicateDraft({
        id: fontCollectionId,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    { translationPrefix: "font_collections.actions.duplicate" }
  );
};
